import { ChevronLeft, User01 } from "@untitled-ui/icons-react";

import Button from "@/components/forms/Button";
import ImageWithFallback from "@/components/media/ImageWithFallback";

import type { GroupInvitePreview } from "../../services/groupInvite";
import MessengerHeader from "../MessengerHeader";
import ChatWaveBackground from "../messages/ChatWaveBackground";

type GroupJoinFallbackViewProps = {
  preview: GroupInvitePreview;
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
  showBackButton?: boolean;
  bottomSlot: React.ReactNode;
};

export default function GroupJoinFallbackView({
  preview,
  open,
  setOpen,
  onClose,
  showBackButton = true,
  bottomSlot,
}: GroupJoinFallbackViewProps) {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <MessengerHeader open={open} setOpen={setOpen} showToggle={false}>
        <div className="flex w-full items-center gap-3">
          {showBackButton && onClose && (
            <Button
              color="tertiary-gray"
              square
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              <ChevronLeft className="size-5 text-gray-600 rtl:rotate-180" />
            </Button>
          )}
          <ImageWithFallback
            src={preview.image_thumb ?? undefined}
            alt={preview.name}
            className="size-10 rounded-full object-cover"
            fallback={
              <div className="flex size-10 items-center justify-center rounded-full bg-gray-100">
                <User01 className="size-6 text-gray-600" />
              </div>
            }
          />
          <span className="text-sm font-semibold text-gray-900">
            {preview.name}
          </span>
        </div>
      </MessengerHeader>

      <ChatWaveBackground>
        <div className="flex-1" />
      </ChatWaveBackground>

      {bottomSlot}
    </div>
  );
}
